const PRICE_LIST_SEIKATSU_NURSING = {
  ID: "seikatsu-nursing",
  PRICE_M: [
    { AGE: 0, 1: 10, 2: 10, 3: 10 },
    { AGE: 1, 1: 10, 2: 10, 3: 10 },
    { AGE: 2, 1: 10, 2: 10, 3: 10 },
    { AGE: 3, 1: 10, 2: 10, 3: 10 },
    { AGE: 4, 1: 10, 2: 10, 3: 10 },
    { AGE: 5, 1: 10, 2: 10, 3: 10 },
    { AGE: 6, 1: 10, 2: 10, 3: 10 },
    { AGE: 7, 1: 10, 2: 10, 3: 10 },
    { AGE: 8, 1: 10, 2: 10, 3: 10 },
    { AGE: 9, 1: 10, 2: 10, 3: 10 },
    { AGE: 10, 1: 10, 2: 10, 3: 10 },
    { AGE: 11, 1: 10, 2: 10, 3: 10 },
    { AGE: 12, 1: 10, 2: 10, 3: 10 },
    { AGE: 13, 1: 10, 2: 10, 3: 10 },
    { AGE: 14, 1: 10, 2: 10, 3: 10 },
    { AGE: 15, 1: 10, 2: 10, 3: 10 },
    { AGE: 16, 1: 10, 2: 10, 3: 10 },
    { AGE: 17, 1: 10, 2: 10, 3: 10 },
    { AGE: 18, 1: 10, 2: 10, 3: 10 },
    { AGE: 19, 1: 10, 2: 10, 3: 10 },
    { AGE: 20, 1: 10, 2: 10, 3: 10 },
    { AGE: 21, 1: 10, 2: 10, 3: 10 },
    { AGE: 22, 1: 10, 2: 10, 3: 10 },
    { AGE: 23, 1: 10, 2: 10, 3: 10 },
    { AGE: 24, 1: 10, 2: 10, 3: 10 },
    { AGE: 25, 1: 10, 2: 10, 3: 20 },
    { AGE: 26, 1: 10, 2: 10, 3: 20 },
    { AGE: 27, 1: 10, 2: 10, 3: 20 },
    { AGE: 28, 1: 10, 2: 10, 3: 20 },
    { AGE: 29, 1: 10, 2: 10, 3: 20 },
    { AGE: 30, 1: 10, 2: 20, 3: 30 },
    { AGE: 31, 1: 10, 2: 20, 3: 30 },
    { AGE: 32, 1: 10, 2: 20, 3: 30 },
    { AGE: 33, 1: 10, 2: 20, 3: 30 },
    { AGE: 34, 1: 10, 2: 20, 3: 30 },
    { AGE: 35, 1: 20, 2: 40, 3: 70 },
    { AGE: 36, 1: 20, 2: 40, 3: 70 },
    { AGE: 37, 1: 20, 2: 40, 3: 70 },
    { AGE: 38, 1: 20, 2: 40, 3: 70 },
    { AGE: 39, 1: 20, 2: 40, 3: 70 },
    { AGE: 40, 1: 40, 2: 90, 3: 130 },
    { AGE: 41, 1: 40, 2: 90, 3: 130 },
    { AGE: 42, 1: 40, 2: 90, 3: 130 },
    { AGE: 43, 1: 40, 2: 90, 3: 130 },
    { AGE: 44, 1: 40, 2: 90, 3: 130 },
    { AGE: 45, 1: 50, 2: 100, 3: 160 },
    { AGE: 46, 1: 50, 2: 100, 3: 160 },
    { AGE: 47, 1: 50, 2: 100, 3: 160 },
    { AGE: 48, 1: 50, 2: 100, 3: 160 },
    { AGE: 49, 1: 50, 2: 100, 3: 160 },
    { AGE: 50, 1: 70, 2: 140, 3: 210 },
    { AGE: 51, 1: 70, 2: 140, 3: 210 },
    { AGE: 52, 1: 70, 2: 140, 3: 210 },
    { AGE: 53, 1: 70, 2: 140, 3: 210 },
    { AGE: 54, 1: 70, 2: 140, 3: 210 },
    { AGE: 55, 1: 100, 2: 200, 3: 310 },
    { AGE: 56, 1: 100, 2: 200, 3: 310 },
    { AGE: 57, 1: 100, 2: 200, 3: 310 },
    { AGE: 58, 1: 100, 2: 200, 3: 310 },
    { AGE: 59, 1: 100, 2: 200, 3: 310 },
    { AGE: 60, 1: 220, 2: 440, 3: 660 },
    { AGE: 61, 1: 220, 2: 440, 3: 660 },
    { AGE: 62, 1: 220, 2: 440, 3: 660 },
    { AGE: 63, 1: 220, 2: 440, 3: 660 },
    { AGE: 64, 1: 220, 2: 440, 3: 660 },
    { AGE: 65, 1: 460, 2: 910, 3: 1370 },
    { AGE: 66, 1: 460, 2: 910, 3: 1370 },
    { AGE: 67, 1: 460, 2: 910, 3: 1370 },
    { AGE: 68, 1: 460, 2: 910, 3: 1370 },
    { AGE: 69, 1: 460, 2: 910, 3: 1370 },
    { AGE: 70, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 71, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 72, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 73, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 74, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 75, 1: 2310, 2: 4610, 3: 6920 },
  ],
  PRICE_F: [
    { AGE: 0, 1: 10, 2: 10, 3: 10 },
    { AGE: 1, 1: 10, 2: 10, 3: 10 },
    { AGE: 2, 1: 10, 2: 10, 3: 10 },
    { AGE: 3, 1: 10, 2: 10, 3: 10 },
    { AGE: 4, 1: 10, 2: 10, 3: 10 },
    { AGE: 5, 1: 10, 2: 10, 3: 10 },
    { AGE: 6, 1: 10, 2: 10, 3: 10 },
    { AGE: 7, 1: 10, 2: 10, 3: 10 },
    { AGE: 8, 1: 10, 2: 10, 3: 10 },
    { AGE: 9, 1: 10, 2: 10, 3: 10 },
    { AGE: 10, 1: 10, 2: 10, 3: 10 },
    { AGE: 11, 1: 10, 2: 10, 3: 10 },
    { AGE: 12, 1: 10, 2: 10, 3: 10 },
    { AGE: 13, 1: 10, 2: 10, 3: 10 },
    { AGE: 14, 1: 10, 2: 10, 3: 10 },
    { AGE: 15, 1: 10, 2: 10, 3: 10 },
    { AGE: 16, 1: 10, 2: 10, 3: 10 },
    { AGE: 17, 1: 10, 2: 10, 3: 10 },
    { AGE: 18, 1: 10, 2: 10, 3: 10 },
    { AGE: 19, 1: 10, 2: 10, 3: 10 },
    { AGE: 20, 1: 10, 2: 10, 3: 10 },
    { AGE: 21, 1: 10, 2: 10, 3: 10 },
    { AGE: 22, 1: 10, 2: 10, 3: 10 },
    { AGE: 23, 1: 10, 2: 10, 3: 10 },
    { AGE: 24, 1: 10, 2: 10, 3: 10 },
    { AGE: 25, 1: 10, 2: 10, 3: 20 },
    { AGE: 26, 1: 10, 2: 10, 3: 20 },
    { AGE: 27, 1: 10, 2: 10, 3: 20 },
    { AGE: 28, 1: 10, 2: 10, 3: 20 },
    { AGE: 29, 1: 10, 2: 10, 3: 20 },
    { AGE: 30, 1: 10, 2: 20, 3: 30 },
    { AGE: 31, 1: 10, 2: 20, 3: 30 },
    { AGE: 32, 1: 10, 2: 20, 3: 30 },
    { AGE: 33, 1: 10, 2: 20, 3: 30 },
    { AGE: 34, 1: 10, 2: 20, 3: 30 },
    { AGE: 35, 1: 20, 2: 40, 3: 70 },
    { AGE: 36, 1: 20, 2: 40, 3: 70 },
    { AGE: 37, 1: 20, 2: 40, 3: 70 },
    { AGE: 38, 1: 20, 2: 40, 3: 70 },
    { AGE: 39, 1: 20, 2: 40, 3: 70 },
    { AGE: 40, 1: 40, 2: 90, 3: 130 },
    { AGE: 41, 1: 40, 2: 90, 3: 130 },
    { AGE: 42, 1: 40, 2: 90, 3: 130 },
    { AGE: 43, 1: 40, 2: 90, 3: 130 },
    { AGE: 44, 1: 40, 2: 90, 3: 130 },
    { AGE: 45, 1: 50, 2: 100, 3: 160 },
    { AGE: 46, 1: 50, 2: 100, 3: 160 },
    { AGE: 47, 1: 50, 2: 100, 3: 160 },
    { AGE: 48, 1: 50, 2: 100, 3: 160 },
    { AGE: 49, 1: 50, 2: 100, 3: 160 },
    { AGE: 50, 1: 70, 2: 140, 3: 210 },
    { AGE: 51, 1: 70, 2: 140, 3: 210 },
    { AGE: 52, 1: 70, 2: 140, 3: 210 },
    { AGE: 53, 1: 70, 2: 140, 3: 210 },
    { AGE: 54, 1: 70, 2: 140, 3: 210 },
    { AGE: 55, 1: 100, 2: 200, 3: 310 },
    { AGE: 56, 1: 100, 2: 200, 3: 310 },
    { AGE: 57, 1: 100, 2: 200, 3: 310 },
    { AGE: 58, 1: 100, 2: 200, 3: 310 },
    { AGE: 59, 1: 100, 2: 200, 3: 310 },
    { AGE: 60, 1: 220, 2: 440, 3: 660 },
    { AGE: 61, 1: 220, 2: 440, 3: 660 },
    { AGE: 62, 1: 220, 2: 440, 3: 660 },
    { AGE: 63, 1: 220, 2: 440, 3: 660 },
    { AGE: 64, 1: 220, 2: 440, 3: 660 },
    { AGE: 65, 1: 460, 2: 910, 3: 1370 },
    { AGE: 66, 1: 460, 2: 910, 3: 1370 },
    { AGE: 67, 1: 460, 2: 910, 3: 1370 },
    { AGE: 68, 1: 460, 2: 910, 3: 1370 },
    { AGE: 69, 1: 460, 2: 910, 3: 1370 },
    { AGE: 70, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 71, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 72, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 73, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 74, 1: 1000, 2: 2010, 3: 3010 },
    { AGE: 75, 1: 2310, 2: 4610, 3: 6920 },
  ],
};
export { PRICE_LIST_SEIKATSU_NURSING };
